import { jsx as _jsx } from "react/jsx-runtime";
import { SvgBan } from '../../index';
import { Tick } from './Tick';
export function RadioTick(props) {
    return (_jsx(Tick, { type: 'radio', icon: _jsx(SvgBan, {}), isHovered: props.isHovered, children: _jsx("input", { type: 'radio', name: props.name, value: props.value, defaultChecked: props.isDefaultChecked, checked: props.isChecked, disabled: props.isDisabled, onChange: props.onChange ? (e) => props.onChange?.(e) : undefined, "aria-invalid": props.isInvalid, "data-test-id": props.testId ? `${props.testId}-input` : undefined }) }));
}
//# sourceMappingURL=RadioTick.js.map